import React, { Children } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PrivacyPolicyPage() {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-1856">
      <Header data-id="element-1857" />
      <main className="flex-grow pt-36 pb-24" data-id="element-1858">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-1859">
          <div className="mb-8" data-id="element-1860">
            <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-700 font-medium" data-id="element-1861">
              <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-1862" />
              Back to Home
            </Link>
          </div>
          <div className="bg-white rounded-xl shadow-md border border-gray-100 p-8 sm:p-10" data-id="element-1863">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6 font-serif" data-id="element-1864">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600" data-id="element-1865">
                Privacy Policy
              </span>
            </h1>
            <p className="text-gray-500 mb-8" data-id="element-1866">Last Updated: August 13, 2025</p>
            <div className="prose prose-lg max-w-none text-gray-700" data-id="element-1867">
              <p data-id="element-1868">
                Creator Boost ("we," "our," or "us") is committed to protecting
                your privacy. This Privacy Policy explains how we collect, use,
                store, transfer, and protect your information when you use any
                of our services— including our tools (such as Newsfiliate and
                any future tools we develop), consulting services, directory
                services, and newsletters (collectively, the "Services").
              </p>
              <p data-id="element-1869">
                By accessing or using any of our Services, you agree to this
                Privacy Policy.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1870">
                1. Information We Collect
              </h2>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1871">
                <li data-id="element-1872">
                  <strong data-id="element-1873">Personal Information:</strong> Information you provide
                  when creating an account, joining our newsletter, purchasing
                  consulting services, or using our tools or directories—such as
                  your name, email address, contact details, and payment
                  information.
                </li>
                <li data-id="element-1874">
                  <strong data-id="element-1875">Account Data:</strong> Information from third-party
                  accounts or integrations you connect to our Services (e.g.,
                  Amazon, Kit.com, social media platforms).
                </li>
                <li data-id="element-1876">
                  <strong data-id="element-1877">Usage Data:</strong> Information about how you
                  interact with our Services (features accessed, time spent,
                  interactions, click data).
                </li>
                <li data-id="element-1878">
                  <strong data-id="element-1879">Device Information:</strong> Details about the device
                  and network you use (IP address, browser type, operating
                  system).
                </li>
                <li data-id="element-1880">
                  <strong data-id="element-1881">Directory Content:</strong> If you use our directory
                  services, we collect the information you submit for listing or
                  searching purposes.
                </li>
              </ul>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1882">
                2. Legal Basis for Processing (GDPR)
              </h2>
              <p data-id="element-1883">
                If you are located in the European Economic Area (EEA), we
                process your personal data on one or more of these lawful bases:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1884">
                <li data-id="element-1885">
                  <strong data-id="element-1886">Consent:</strong> You have given clear consent for a
                  specific purpose.
                </li>
                <li data-id="element-1887">
                  <strong data-id="element-1888">Contractual Necessity:</strong> Processing is
                  necessary to perform our contract with you or take steps
                  before entering a contract.
                </li>
                <li data-id="element-1889">
                  <strong data-id="element-1890">Legitimate Interests:</strong> Processing is necessary
                  for our legitimate interests (e.g., improving our Services),
                  provided your rights do not override them.
                </li>
                <li data-id="element-1891">
                  <strong data-id="element-1892">Legal Obligations:</strong> Processing is necessary to
                  comply with a legal obligation.
                </li>
              </ul>
              <p className="mt-4" data-id="element-1893">
                We do not specifically target or market our Services to EU/EEA
                residents. However, if you are in the EU/EEA and use our
                Services, you retain all rights granted under the GDPR.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1894">
                3. International Data Transfers
              </h2>
              <p data-id="element-1895">
                Your data may be transferred to and stored on servers outside
                your country of residence, including in the United States. Where
                data is transferred from the EEA to countries without an
                adequacy decision, we use safeguards such as Standard
                Contractual Clauses approved by the European Commission.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1896">
                4. Cookies and Tracking Technologies
              </h2>
              <p data-id="element-1897">We use cookies and similar technologies to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1898">
                <li data-id="element-1899">Provide and improve our Services</li>
                <li data-id="element-1900">Analyze usage trends</li>
                <li data-id="element-1901">Personalize content and marketing</li>
              </ul>
              <p className="mt-4" data-id="element-1902">
                If you reside in the EU, we will obtain your consent before
                placing non-essential cookies. You can manage your cookie
                preferences via our cookie banner and browser settings.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1903">
                5. Third-Party Services & Integrations
              </h2>
              <p data-id="element-1904">
                Some of our Services integrate with third-party platforms (e.g.,
                Kit.com, Amazon, payment processors). Their privacy policies
                will apply in addition to ours. We encourage you to review them,
                as we do not control their practices.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1905">
                6. Data Security & Retention
              </h2>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1906">
                <li data-id="element-1907">
                  <strong data-id="element-1908">Security:</strong> We use industry-standard security
                  measures (encryption, access controls) to protect your data.
                </li>
                <li data-id="element-1909">
                  <strong data-id="element-1910">Retention:</strong> We keep your personal data as long
                  as necessary to:
                  <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-1911">
                    <li data-id="element-1912">Deliver Services</li>
                    <li data-id="element-1913">Comply with legal obligations</li>
                    <li data-id="element-1914">Resolve disputes</li>
                    <li data-id="element-1915">Enforce agreements</li>
                  </ul>
                </li>
              </ul>
              <p className="mt-4" data-id="element-1916">
                You may request deletion of your data by contacting us at
                gavin.smith@creatorboost.ai.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1917">
                7. Your Privacy Rights
              </h2>
              <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3" data-id="element-1918">
                7.1 Global Rights
              </h3>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1919">
                <li data-id="element-1920">
                  <strong data-id="element-1921">Access:</strong> Request a copy of your personal data.
                </li>
                <li data-id="element-1922">
                  <strong data-id="element-1923">Correction:</strong> Request corrections to inaccurate
                  or incomplete data.
                </li>
                <li data-id="element-1924">
                  <strong data-id="element-1925">Deletion:</strong> Request deletion, subject to legal
                  exceptions.
                </li>
                <li data-id="element-1926">
                  <strong data-id="element-1927">Restriction:</strong> Request limited processing under
                  certain conditions.
                </li>
                <li data-id="element-1928">
                  <strong data-id="element-1929">Data Portability:</strong> Receive your data in a
                  portable format.
                </li>
                <li data-id="element-1930">
                  <strong data-id="element-1931">Withdraw Consent:</strong> Where applicable, withdraw
                  consent at any time.
                </li>
              </ul>
              <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3" data-id="element-1932">
                7.2 EU/EEA Rights (GDPR)
              </h3>
              <p data-id="element-1933">If you reside in the EEA, you may also:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1934">
                <li data-id="element-1935">
                  Lodge a complaint with your local data protection authority.
                </li>
                <li data-id="element-1936">
                  Request details of safeguards applied when your data is
                  transferred outside the EEA.
                </li>
              </ul>
              <p className="mt-4" data-id="element-1937">
                We have not appointed an EU Representative, as we do not
                specifically target EU/EEA residents, but we comply with GDPR
                requirements for EU/EEA users.
              </p>
              <h3 className="text-xl font-bold text-gray-800 mt-6 mb-3" data-id="element-1938">
                7.3 California Privacy Rights (CCPA/CPRA)
              </h3>
              <p data-id="element-1939">If you are a California resident, you have the right to:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1940">
                <li data-id="element-1941">
                  Know the categories of personal information we collect,
                  sources, purposes, and third parties with whom we share it.
                </li>
                <li data-id="element-1942">
                  Opt out of the "sale" or "sharing" of your personal
                  information (as defined by California law).
                </li>
                <li data-id="element-1943">
                  Request deletion of your personal information, subject to
                  certain exceptions.
                </li>
                <li data-id="element-1944">
                  Not be discriminated against for exercising your rights.
                </li>
              </ul>
              <p className="mt-4" data-id="element-1945">
                To exercise these rights, contact gavin.smith@creatorboost.ai or
                use our "Do Not Sell or Share My Info" page (if applicable).
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1946">
                8. Children's Privacy
              </h2>
              <p data-id="element-1947">
                Our Services are not intended for individuals under 18. We do
                not knowingly collect data from children. If we learn that a
                minor has provided us with personal data, we will delete it
                promptly.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1948">
                9. Changes to This Privacy Policy
              </h2>
              <p data-id="element-1949">
                We may update this Privacy Policy from time to time. Significant
                changes will be communicated via email or through our Services.
                Continued use after the effective date means you accept the
                updated policy.
              </p>
              <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-1950">
                10. Contact Us
              </h2>
              <p className="mt-2" data-id="element-1951">
                <strong data-id="element-1952">Email:</strong> gavin.smith@creatorboost.ai
              </p>
              <p data-id="element-1953">
                <strong data-id="element-1954">Address:</strong> 3500 S Dupont Highway, Dover, Delaware
                19901
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-1955" />
    </div>;
}